(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
